module.exports = __webpack_public_path__ + "pe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pe.svg
// module id = 1005
// module chunks = 0